import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=c87c2448&"
import script from "./Background.vue?vue&type=script&lang=js&"
export * from "./Background.vue?vue&type=script&lang=js&"
import style0 from "./Background.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports